import { Box, Flex, Spinner, Text } from '@chakra-ui/react';

const Loading = () => {
    return (
        <Box d="flex" top="0" bottom="0" left="0" right="0" position="fixed" alignItems="center" justifyContent="center" zIndex="9999">
            <Box h="100%" w="100%" opacity="85%" bgColor="#333" ></Box>
            <Flex position="fixed" left={0} right={0} top={0} bottom={0} alignItems="center" justifyContent="center">
                <Flex justify={"center"} align="center" direction="column">
                    <Spinner size="lg" h="60px" w={"60px"} color='white' thickness='8px'/>
                    <Text mt={4} color="white" fontSize="lg">Carregando...</Text>
                </Flex>
            </Flex>
        </Box>
    )
}

export default Loading;